import React, {useEffect} from 'react';
import db from '../firebase/firebaseConfig'
import { collection, addDoc, doc, onSnapshot } from "firebase/firestore";
import SalaDeChat from '../components/Chats'
import 'bootstrap/dist/css/bootstrap.min.css';


const Datos = () => {


    useEffect (() => {
        console.log('Se carga la info de Firebase')

        onSnapshot(
            collection(db, 'datos-1'),
            (snapshot) => {
                const arregloDatos = snapshot.docs.map((documento) => {
                    return {...documento.data(), id: documento.id}
                })
                cambiarDatos(arregloDatos);
            },
            (error) => {
                console.log('Hubo un error al cargar la base de Firebase')
                console.log(error)
            }
        )
    },[])

    const [datos, cambiarDatos] = React.useState([])

    return ( 
        <div className="col-12">
            {datos.map((dato) => {
            return (
                <SalaDeChat key={dato.id}
                id={dato.id}
                // nombre={dato.nombre}
                mensaje={dato.mensaje}/>
                )
            })}
        </div>
    );
}



 
export default Datos;